import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, withKeys as _withKeys, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-36763f3c"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "users-set"
};
const _hoisted_2 = {
  class: "title"
};

const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 当前已设置的用户（ ");

const _hoisted_4 = {
  style: {
    "color": "#f56c6c"
  }
};

const _hoisted_5 = /*#__PURE__*/_createTextVNode("个） ");

const _hoisted_6 = {
  class: "modified_user_list"
};

const _hoisted_7 = /*#__PURE__*/_createTextVNode("+ 添加新用户");

const _hoisted_8 = /*#__PURE__*/_createTextVNode("确认添加");

const _hoisted_9 = {
  class: "modified_user_list"
};
const _hoisted_10 = {
  class: "confirm-users"
};

const _hoisted_11 = /*#__PURE__*/_createTextVNode("重置");

const _hoisted_12 = /*#__PURE__*/_createTextVNode("批量设置");

const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tips-box"
}, [/*#__PURE__*/_createTextVNode(" 提示： "), /*#__PURE__*/_createElementVNode("ol", null, [/*#__PURE__*/_createElementVNode("li", null, "请先选择用户再进行设置。"), /*#__PURE__*/_createElementVNode("li", null, "最多只能修改15个用户。"), /*#__PURE__*/_createElementVNode("li", null, "只限制于分公司设置多账户降赔。")])], -1));

const _hoisted_14 = {
  key: 1
};
const _hoisted_15 = {
  class: "dialog-title"
};

const _hoisted_16 = /*#__PURE__*/_createTextVNode(" 特殊用户设置 ");

const _hoisted_17 = /*#__PURE__*/_createTextVNode("关闭");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_tag = _resolveComponent("el-tag");

  const _component_el_input = _resolveComponent("el-input");

  const _component_el_button = _resolveComponent("el-button");

  const _component_el_col = _resolveComponent("el-col");

  const _component_el_row = _resolveComponent("el-row");

  const _component_usersBatchSetLossGames = _resolveComponent("usersBatchSetLossGames");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [!$data.dialog.visible ? (_openBlock(), _createBlock(_component_el_row, {
    key: 0,
    gutter: 50
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 12
    }, {
      default: _withCtx(() => [_createElementVNode("div", null, [_hoisted_3, _createElementVNode("span", _hoisted_4, _toDisplayString($data.modified_user_list.length), 1), _hoisted_5]), _createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.modified_user_list, item => {
        return _openBlock(), _createBlock(_component_el_tag, {
          class: "username",
          size: "small",
          closable: "",
          key: item.user_id,
          onClick: $event => $options.sub_user(item),
          onClose: $event => $options.handleClose('old', item.user_id)
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(item.username), 1)]),
          _: 2
        }, 1032, ["onClick", "onClose"]);
      }), 128))]), _createElementVNode("div", null, [$data.inputVisible ? (_openBlock(), _createBlock(_component_el_input, {
        key: 0,
        class: "input-new-tag",
        modelValue: $data.inputValue,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.inputValue = $event),
        ref: "saveTagInput",
        size: "small",
        onKeyup: _withKeys($options.handleInputConfirm, ["enter"]),
        onBlur: $options.handleInputConfirm
      }, null, 8, ["modelValue", "onKeyup", "onBlur"])) : (_openBlock(), _createBlock(_component_el_button, {
        key: 1,
        class: "button-new-tag",
        plain: "",
        type: "primary",
        size: "small",
        onClick: $options.showInput
      }, {
        default: _withCtx(() => [_hoisted_7]),
        _: 1
      }, 8, ["onClick"])), _createVNode(_component_el_button, {
        type: "primary",
        size: "small"
      }, {
        default: _withCtx(() => [_hoisted_8]),
        _: 1
      }), _createElementVNode("span", null, "已添加：" + _toDisplayString($data.newUsers.length) + "个", 1), _createElementVNode("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.newUsers, item => {
        return _openBlock(), _createBlock(_component_el_tag, {
          class: "username",
          size: "small",
          closable: "",
          key: item,
          onClose: $event => $options.handleClose('new', item)
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(item), 1)]),
          _: 2
        }, 1032, ["onClose"]);
      }), 128))])]), _createElementVNode("div", _hoisted_10, [_createVNode(_component_el_button, {
        size: "small",
        type: "info",
        onClick: $options.refresh
      }, {
        default: _withCtx(() => [_hoisted_11]),
        _: 1
      }, 8, ["onClick"]), _createVNode(_component_el_button, {
        size: "small",
        type: "primary",
        onClick: $options.sub_users
      }, {
        default: _withCtx(() => [_hoisted_12]),
        _: 1
      }, 8, ["onClick"])])]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 12
    }, {
      default: _withCtx(() => [_hoisted_13]),
      _: 1
    })]),
    _: 1
  })) : _createCommentVNode("", true), $data.dialog.visible ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_hoisted_16, _createVNode(_component_el_button, {
    style: {
      "float": "right"
    },
    type: "",
    size: "small",
    onClick: $options.close
  }, {
    default: _withCtx(() => [_hoisted_17]),
    _: 1
  }, 8, ["onClick"])]), _createVNode(_component_usersBatchSetLossGames, {
    ref: "usersBatchSetLossGames",
    onCancel: $options.cancel,
    game_list: $props.game_list
  }, null, 8, ["onCancel", "game_list"])])) : _createCommentVNode("", true)])]);
}